export const PROJECT_ID = 'Oneclub'
export const ACT = 'weboneclubdata'
